import { Popover, useTheme } from "@mui/material";
import { useProviderSearchContext } from "context/ProviderSearchContext";
import RSButton from "ds_legacy/components/RSButton";
import { HorizontalDivider, VerticalLayout } from "ds_legacy/materials/layouts";
import { dp, margin, padding, sizing } from "ds_legacy/materials/metrics";
import { Body, FONT_SIZE_14, Subheading } from "ds_legacy/materials/typography";
import {
  PROVIDER_SEARCH_LOGIN_MODAL,
  PROVIDER_SEARCH_SIGNUP_MODAL,
  ProviderRegistrationInfo,
} from "dsl/ecosystems/ProviderSearchLoginModal/shared";
import { InfoIcon } from "lucide-react";
import { useTranslations } from "translations";

export const RegistrationPopover = ({
  anchor,
  isOpen,
  onClose,
}: {
  anchor: Element | null;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const translations = useTranslations();
  const { setLoginModal } = useProviderSearchContext();
  const theme = useTheme();

  return (
    <Popover
      anchorEl={anchor}
      anchorOrigin={{
        horizontal: "right",
        vertical: "bottom",
      }}
      open={isOpen}
      PaperProps={{ sx: { margin: margin(1, 0, 0) } }}
      transformOrigin={{
        horizontal: "right",
        vertical: "top",
      }}
      onClose={onClose}
    >
      <VerticalLayout
        borderRadius={dp(8)}
        padding={padding(3, 4)}
        width={sizing(42)}
      >
        <VerticalLayout aligned padding={padding(1, 4)}>
          <InfoIcon size={32} style={{ color: theme.palette.primary.main }} />
          <VerticalLayout
            style={{ alignItems: "flex-start", margin: margin(2, 0, 1) }}
          >
            <Subheading margin={margin(0, 0, 1)} whiteSpace="nowrap">
              {translations.providersearch.loginDropDown.title}
            </Subheading>
            <ul
              style={{
                listStyle: "unset",
                margin: margin(0),
                padding: padding(0, 0, 0, 2.5),
              }}
            >
              <li>
                <Body as="p" fontSize={FONT_SIZE_14} margin={margin(0)}>
                  {translations.providersearch.loginDropDown.bulletOne}
                </Body>
              </li>
              <li>
                <Body as="p" fontSize={FONT_SIZE_14} margin={margin(0)}>
                  {translations.providersearch.loginDropDown.bulletTwo}
                </Body>
              </li>
              <li>
                <Body as="p" fontSize={FONT_SIZE_14} margin={margin(0)}>
                  {translations.providersearch.loginDropDown.bulletThreee}
                </Body>
              </li>
              <li>
                <Body as="p" fontSize={FONT_SIZE_14} margin={margin(0)}>
                  {translations.providersearch.loginDropDown.bulletFour}
                </Body>
              </li>
            </ul>
          </VerticalLayout>
        </VerticalLayout>
        <RSButton
          ariaProps={{
            "aria-haspopup": "dialog",
          }}
          color="primary"
          id="login"
          loading="na"
          style={{ margin: margin(1, 0), width: "100%" }}
          variant="outlined"
          onClick={() => {
            setLoginModal(PROVIDER_SEARCH_LOGIN_MODAL);
            onClose();
          }}
        >
          {translations.providersearch.loginDropDown.loginButton}
        </RSButton>
        <RSButton
          ariaProps={{
            "aria-haspopup": "dialog",
          }}
          color="primary"
          id="signup"
          loading="na"
          style={{ margin: margin(1, 0), width: "100%" }}
          variant="outlined"
          onClick={() => {
            setLoginModal(PROVIDER_SEARCH_SIGNUP_MODAL);
            onClose();
          }}
        >
          {translations.providersearch.loginDropDown.createAccountButton}
        </RSButton>
        <HorizontalDivider
          color={theme.palette.neutrals.medium_grey}
          style={{ margin: margin(2, 0, 1) }}
        />
        <ProviderRegistrationInfo />
      </VerticalLayout>
    </Popover>
  );
};
